module.exports = __webpack_public_path__ + "static/media/hint.a00e53cd.ogg";